export default {
  // Navigation
  'nav.home': 'Home',
  'nav.products': 'Products',
  'nav.cuttingThickness': 'Cutting Thickness',
  'nav.fairs': 'Trade Shows',
  'nav.getQuote': 'Request Quote',
  'nav.eCatalog': 'E-Catalog',
  'nav.onlineOrder': 'Online Order',
  'nav.features': 'Features',

  // Hero Section
  'hero.badge': 'American Quality • Global Standards',
  'hero.title1': 'Fiber Laser',
  'hero.title2': 'Cutting Systems',
  'hero.title3': 'Industrial Solutions',
  'hero.description': 'Safe and high-performance fiber laser cutting solutions developed by AJAN LASER USA, suitable for serial production.',
  'hero.getQuote': 'Request Quote',
  'hero.exploreProducts': 'Explore Products',

  // Products Section
  'products.title': 'Our Products',
  'products.subtitle': 'Comprehensive solutions for industrial laser cutting',
  'products.viewDetails': 'View Details',
  'products.enclosed': 'Fully Enclosed Fiber Laser',
  'products.enclosedDesc': 'Compact design and high safety standards',
  'products.gantry': 'Enclosed Gantry Fiber Laser',
  'products.gantryDesc': 'Advanced systems for large sheet cutting',
  'products.tube': 'Tube and Profile Fiber Laser',
  'products.tubeDesc': 'Advanced systems for tube and profile cutting',

  // Application Areas
  'app.title': 'Application Areas',
  'app.aluminum': 'Aluminum',
  'app.aluminumDesc': '0.02-1 inch',
  'app.carbonSteel': 'Carbon Steel',
  'app.carbonSteelDesc': '0.02-1.6 inch',
  'app.brass': 'Brass',
  'app.brassDesc': '0.02-0.8 inch',
  'app.stainlessSteel': 'Stainless Steel',
  'app.stainlessSteelDesc': '0.02-1.2 inch',
  'app.otherMetals': 'Other Metals',
  'app.otherMetalsDesc': 'Copper, Bronze, Galvanized Steel',
  'app.materialsTitle': 'Applicable Materials',
  'app.materialsDesc1': 'With AJAN LASER fiber laser cutting machines, you can perform high-precision cutting operations on various metal materials.',
  'app.materialsDesc2': 'Our machines provide superior cutting performance on aluminum, carbon steel, stainless steel, brass, copper, and many other metal materials.',
  'app.materialsDesc3': 'With advanced fiber laser technology, you can achieve high speed, precision, and quality cutting in industrial production.',

  // Trust Section
  'trust.badge': 'Trust and Experience',
  'trust.title': 'Over 50 Years of Industry Experience',
  'trust.description': 'AJAN LASER is part of the AJAN group of companies, which has been operating in the industrial equipment sector since 1973. We provide reliable laser cutting solutions to customers worldwide.',
  'trust.experience': 'Years of Experience',
  'trust.machines': 'Machines Installed',
  'trust.countries': 'Countries',
  'trust.laserRD': 'Years of Laser R&D',
  'trust.leadership': 'Industry Leadership',
  'trust.leadershipDesc': 'We are one of the leading CNC machine manufacturers and provide world-class solutions.',
  'trust.deepRoots': 'Deep Roots',
  'trust.deepRootsDesc': 'With over 50 years of industry experience, we offer reliable and durable solutions.',
  'trust.rdPeak': 'R&D Peak',
  'trust.rdPeakDesc': 'We continuously invest in research and development to offer innovative laser cutting solutions.',

  // Certifications
  'cert.title': 'Quality and Safety Standards',
  'cert.description': 'Our products comply with international quality and safety standards.',
  'cert.ce': 'CE',
  'cert.ceDesc': 'European Conformity',
  'cert.iso12100': 'ISO 12100',
  'cert.iso12100Desc': 'Machine Safety',
  'cert.iso60204': 'ISO 60204',
  'cert.iso60204Desc': 'Electrical Safety',
  'cert.iso60974': 'ISO 60974',
  'cert.iso60974Desc': 'Welding Equipment',
  'cert.emcLvd': 'EMC/LVD',

  // Service Section
  'service.title': 'After Sales Service',
  'service.subtitle': 'We are always with you with our professional technical support team',
  'service.warranty': '2 Year Warranty',
  'service.warrantyDesc': 'All our machines come with a 2-year manufacturer warranty. During the warranty period, all manufacturing defects are repaired free of charge.',
  'service.exclusions': 'Warranty Exclusions',
  'service.exclusionsDesc': 'Consumables such as laser heads, lenses, nozzles, and damages caused by misuse are not covered by the warranty.',
  'service.technicalSupport': 'Technical Support',
  'service.fastService': 'Fast Service',
  'service.spareParts': 'Spare Parts',
  'service.expertTeam': 'Expert Team',

  // Why Choose Us
  'why.title': 'Why AJAN LASER USA?',
  'why.subtitle': 'Reasons to choose us for laser cutting solutions',
  'why.reliableTech': 'Reliable Technology',
  'why.reliableTechDesc': 'We offer durable and reliable solutions using high-quality components from world brands.',
  'why.affordableCost': 'Competitive Pricing',
  'why.affordableCostDesc': 'We offer competitive prices with local support and direct sales.',
  'why.continuousInnovation': 'Continuous Innovation',
  'why.continuousInnovationDesc': 'We continuously improve our products through research and development.',
  'why.customerFocused': 'Customer Focused',
  'why.customerFocusedDesc': 'We provide customized solutions and fast technical support.',

  // Features
  'features.speedDesc': 'High cutting speed and precision',
  'features.domesticProduction': 'American Support',
  'features.domesticProductionDesc': 'Local support and quality',
  'features.serviceNetwork': 'Service Network',
  'features.serviceNetworkDesc': 'Fast technical support',
  'features.easyToUse': 'Easy to Use',
  'features.easyToUseDesc': 'User-friendly interface',

  // CTA Section
  'cta.title': 'Ready to Upgrade Your Production?',
  'cta.subtitle': 'Contact us for detailed information about our laser cutting solutions',
  'cta.callNow': 'Call Now',
  'cta.viewCatalogs': 'View Catalogs',

  // Contact Form
  'form.title': 'Request a Quote',
  'form.subtitle': 'Fill out the form and we will contact you shortly',
  'form.companyName': 'Company Name',
  'form.companyNamePlaceholder': 'Enter company name',
  'form.fullName': 'Full Name',
  'form.fullNamePlaceholder': 'Enter your name',
  'form.email': 'Email',
  'form.emailPlaceholder': 'Enter your email',
  'form.phone': 'Phone',
  'form.phonePlaceholder': 'Enter your phone',
  'form.address': 'Address',
  'form.addressPlaceholder': 'Enter your address (City, State, ZIP)',
  'form.message': 'Message',
  'form.messagePlaceholder': 'Enter your message',
  'form.characters': 'characters',
  'form.submit': 'Submit',
  'form.submitting': 'Submitting...',
  'form.success': 'Your message has been sent successfully!',
  'form.error': 'An error occurred. Please try again.',

  // Footer
  'footer.description': 'High-performance fiber laser systems engineered for modern manufacturing.',
  'footer.quickLinks': 'Quick Links',
  'footer.home': 'Home',
  'footer.catalog': 'Catalog',
  'footer.fairs': 'Trade Shows',
  'footer.cuttingThickness': 'Cutting Thickness',
  'footer.contact': 'Contact',
  'footer.phone': 'Phone:',
  'footer.fax': 'Fax:',
  'footer.email': 'Email:',
  'footer.address': 'Address:',
  'footer.factory': 'Office:',
  'footer.customerService': 'Customer Service:',
  'footer.certifications': 'Certifications',
  'footer.ceCertificate': 'CE Certificate',
  'footer.iso9001': 'ISO 9001',
  'footer.emcLvdTests': 'EMC and LVD Tests',
  'footer.tsEnIso12100': 'TS EN ISO 12100',
  'footer.rights': '© 2025 AJAN USA LLC. All rights reserved.',
  'footer.websiteBuilder': 'Built with Readdy',

  // Specs
  'specs.laserPower': 'Laser Power',
  'specs.zAxisHeight': 'Z-Axis Height',
  'specs.xyPositionAccuracy': 'XY Position Accuracy',
  'specs.xyRepeatAccuracy': 'XY Repeat Accuracy',
  'specs.xyMaxSpeed': 'XY Max Speed',
  'specs.xyMaxSpeedValue': 'Up to 492 ft/min',
  'specs.xyMaxSpeedIdle': 'XY Max Speed (Idle)',
  'specs.xyMaxSpeedIdleValue': 'Up to 328 ft/min',
  'specs.xyMaxAcceleration': 'XY Max Acceleration',
  'specs.laserSource': 'Laser Source',
  'specs.laserHead': 'Laser Head',
  'specs.body': 'Body',
  'specs.bodyValue': 'Welded Steel Structure',
  'specs.xyRail': 'XY Rail',
  'specs.xyRack': 'XY Rack',
  'specs.xyRackValue': 'Hardened and Ground',
  'specs.servoMotors': 'Servo Motors',
  'specs.reducer': 'Reducer',
  'specs.electricalComponents': 'Electrical Components',
  'specs.lubricationSystem': 'Lubrication System',
  'specs.lubricationSystemValue': 'Automatic Centralized',
  'specs.chiller': 'Chiller',
  'specs.pneumaticComponents': 'Pneumatic Components',
  'specs.cncControl': 'CNC Control',

  // Fairs
  'fairs.title': 'Trade Shows',
  'fairs.subtitle': 'We meet you at leading industry trade shows',
  'fairs.upcoming': 'Upcoming Trade Shows',
  'fairs.upcomingDesc': 'Visit our booth at upcoming trade shows',
  'fairs.past': 'Past Trade Shows',
  'fairs.pastDesc': 'Trade shows we have participated in',
  'fairs.details': 'Details',
  'fairs.noUpcoming': 'No upcoming trade shows scheduled',
  'fairs.noPast': 'No past trade shows',
  'fairs.ctaTitle': 'Want to meet at a trade show?',
  'fairs.ctaSubtitle': 'Call us to schedule a meeting',
  'fairs.callForAppointment': 'Call for Appointment',
};
